import { Map, List } from 'immutable';

import ReviewsConstants from 'Shared/constants/Reviews.constants';

export const getSlug = reviewItem => {
  if (!Map.isMap(reviewItem)) {
    return false;
  }
  return reviewItem.get(ReviewsConstants.Model.SLUG);
};

export const getReviewTemplate = reviewItem => {
  if (!Map.isMap(reviewItem)) {
    return false;
  }
  return reviewItem.get(ReviewsConstants.Model.REVIEW_TEMPLATE);
};

export const getCreatedAt = reviewItem => {
  if (!Map.isMap(reviewItem)) {
    return false;
  }
  return reviewItem.get(ReviewsConstants.Model.CREATED_AT, '');
};

export const getSelf360 = reviewItem => {
  if (!Map.isMap(reviewItem)) {
    return false;
  }
  return reviewItem.get(ReviewsConstants.Model.SELF_360, '');
};

export const getCanChangeCompiler = reviewItem => {
  if (!Map.isMap(reviewItem)) {
    return false;
  }
  return reviewItem.get(ReviewsConstants.Model.CAN_CHANGE_COMPILER);
};

export const getReviewTemplateReviewForms = reviewItem => {
  if (!Map.isMap(reviewItem)) {
    return false;
  }
  return reviewItem.getIn([ReviewsConstants.Model.REVIEW_TEMPLATE, ReviewsConstants.Model.REVIEW_FORM_TEMPLATES]);
};

export const getReceiverSlug = reviewItem => {
  if (!Map.isMap(reviewItem)) {
    return false;
  }
  return reviewItem.get(ReviewsConstants.Model.RECEIVER_SLUG, '');
};

export const getReceiverViewedAt = reviewItem => {
  if (!Map.isMap(reviewItem)) {
    return false;
  }
  return reviewItem.get(ReviewsConstants.Model.RECEIVER_VIEWED_AT, '');
};

export const getCompilerSlug = reviewItem => {
  if (!Map.isMap(reviewItem)) {
    return false;
  }
  return reviewItem.get(ReviewsConstants.Model.COMPILER_SLUG, '');
};

export const getCreatorSlug = reviewItem => {
  if (!Map.isMap(reviewItem)) {
    return false;
  }
  return reviewItem.get(ReviewsConstants.Model.CREATOR_SLUG, '');
};

export const getState = reviewItem => {
  if (!Map.isMap(reviewItem)) {
    return false;
  }
  return reviewItem.get(ReviewsConstants.Model.STATE, '');
};

export const getHistory = reviewItem => {
  if (!Map.isMap(reviewItem)) {
    return false;
  }
  return reviewItem.get(ReviewsConstants.Model.HISTORY, List());
};

export const getPeerReviewDueBy = reviewItem => {
  if (!Map.isMap(reviewItem)) {
    return false;
  }
  return reviewItem.get(ReviewsConstants.Model.PEER_REVIEW_DUE_BY, '');
};

export const getDuBy = reviewItem => {
  if (!Map.isMap(reviewItem)) {
    return false;
  }
  return reviewItem.get(ReviewsConstants.Model.DUE_BY, '');
};

export const getPeerReviewRecipientSharingSetting = reviewItem => {
  if (!Map.isMap(reviewItem)) {
    return false;
  }
  return reviewItem.get(ReviewsConstants.Model.PEER_REVIEW_RECIPIENT_SHARING_SETTING, '');
};

export const getUnlockedAt = reviewItem => {
  if (!Map.isMap(reviewItem)) {
    return false;
  }
  return reviewItem.get(ReviewsConstants.Model.UNLOCKED_AT, '');
};

export const getReviewTemplateVersion = reviewItem => {
  if (!Map.isMap(reviewItem)) {
    return false;
  }
  return reviewItem.get(ReviewsConstants.Model.REVIEW_TEMPLATE_VERSION, '');
};

export const getReviewCycleSlug = reviewItem => {
  if (!Map.isMap(reviewItem)) {
    return null;
  }
  return reviewItem.get(ReviewsConstants.Model.REVIEW_CYCLE_SLUG, '') as string;
};
